import { Cookies } from '@clickfunnels2/cfhoy.js'

document.addEventListener('DOMContentLoaded', function () {
  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)

  // 30 days * 24 hours * 60 minutes (1 month expiration)
  const ttl = 30 * 24 * 60

  const workspace_sharing_id = urlParams.get('workspace_sharing_id')
  if (workspace_sharing_id) {
    Cookies.set('workspace_sharing_id', workspace_sharing_id, ttl)
  }

  // Handle resource_install_intent for cross-domain funnel sharing
  // Rails checks signed cookie first, falls back to unsigned with validation
  // Set ttl to 24 hours for cross-domain flow
  const resource_install_intent_ttl = 24 * 60 * 60 // 24 hours
  const resource_install_intent = urlParams.get('resource_install_intent')
  if (resource_install_intent) {
    Cookies.set('resource_install_intent', resource_install_intent, resource_install_intent_ttl)
  }
})
